<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ItemPriceHome',
}
</script>
